import { styled } from '@mui/material';

const WatermarkStyled = styled('div')`
  position: fixed;
  width: 100%;
  top: 30%;
  text-align: center;
  opacity: 0.5;
  z-index: 99999;
  color: white;
  transform: rotate(-30deg);
  font-size: 30vh;
  pointer-events: none;
  @media (orientation: portrait) {
    transform: rotate(-45deg);
    font-size: 22vh;
  }
`;

export default WatermarkStyled;
